<template>
  <div>已通过新窗口打开</div>
</template>

<script>
import { mapState } from "vuex";
import { getToken } from "@/CommonDP/utils";
export default {
  name: "LargeScreenDesign",
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjId: (state) => state.projectMg.prjObj.prjId
    })
  },
  created() {
    const token = getToken();
    setTimeout(() => {
      window.open(`${location.origin}/common-dp-report/#/project/items?token=${token}&prjId=${this.prjId}&enterpriseId=${this.enterpriseId}`, "_blank");
    }, 500);
  }
};
</script>
